Apt.fn.extend('filters', {}, {
	/**
	 * Bind filter check events
	 */
	bindCheck() {
		const scope = this;
		const $checks = $$('filterCheck');

		$.events.on('$filterCheck', 'change', (e, el) => {
			if (
				el.name === 'tag' ||
				el.name === 'type'
			) {
				$.app.filters.$set('input.' + el.name, $checks.filter('[name="' + el.name + '"][checked]').map(item => item.value));
			}

			scope.merge();
		}, {
			delegate: '$filters',
			namespace: 'filters'
		});
	},

	/**
	 * Process the keyup event for evaluation
	 *
	 * @param {HTMLElement} el
	 * @param {Number} key
	 */
	processCheck(el, key) {
		const scope = this;
		const activeClass = '-is-active';

		if (scope.$activeCheck) {
			scope.$activeCheck.removeClass(activeClass);

			scope.$activeCheck = key === 40 ?
				scope.$activeCheck.next() :
				scope.$activeCheck.prev();
		} else {
			scope.$entries = $('input[type="checkbox"]', $(el).next('$filterContent'));

			if (scope.$entries.length) {
				scope.$activeCheck = key === 40 ?
					scope.$entries.first() :
					scope.$entries.last();
			} else {
				scope.$activeCheck = false;
			}
		}

		if (scope.$activeCheck.length) {
			scope.$activeCheck.addClass(activeClass);
		} else {
			scope.$activeCheck = false;
		}
	},

	/**
	 * Make check option selection
	 */
	selectCheck() {
		const $check = $$('filterCheck', this.$activeCheck);

		$check.prop('checked', ! $check.prop('checked'))
			.trigger('change');

		this.$activeCheck[0].classList.add('-is-active');
	}
});